module.exports = __webpack_public_path__ + "img/5_misc_games.b0d92a33.png";